import { Body, H1 } from "../Typography";
import Link from "next/link";
import { APPLICATION_ROUTES } from "../../shared-logic/routes";
import { type JSX } from "react";
import { CTASize, MarketingCTA } from "../MarketingCTA";
import {
    ButtonWrapper,
    DesktopImage,
    LightTitleSection,
    MarketingUseCaseHeaders,
    MarketingUserCaseText,
    MobileImage,
    UseCaseLink
} from "./MarketingUseCaseHeader.styles";
import { VerticalSpacing } from "../VerticalSpacing";
import { MarketingTitle } from "../ReusableStyledComponents/MarketingMainTitle";
import { OptionalLink } from "../ReusableStyledComponents/OptionalLink";

type MarketingUseCaseHeaderProps = {
    title?: string | JSX.Element;
    description: string | JSX.Element;
    desktopImage: JSX.Element;
    userBio?: JSX.Element;
    mobileImage: JSX.Element;
    link?: string;
    CTAText?: string;
    profileLink?: string;
    useCTA?: boolean;
    useAuthoryFor?: boolean;
    customImageMaxWidth?: number;
    customRightComponentMargin?: string;
};

export const MarketingUseCaseHeader = ({
    title,
    description,
    desktopImage,
    mobileImage,
    link = APPLICATION_ROUTES.SIGNUP,
    profileLink = "",
    CTAText = "Get started",
    userBio,
    useCTA = true,
    useAuthoryFor = true,
    customImageMaxWidth,
    customRightComponentMargin
}: MarketingUseCaseHeaderProps) => (
    <MarketingUseCaseHeaders
        useAuthoryFor={useAuthoryFor}
        customImageMaxWidth={customImageMaxWidth}
        customRightComponentMargin={customRightComponentMargin}
    >
        <div>
            <MarketingUserCaseText>
                {useAuthoryFor ? (
                    <H1 as="h1">
                        <LightTitleSection>Authory for</LightTitleSection>
                        <br />
                        <strong>{title}</strong>
                    </H1>
                ) : (
                    <>{!!title ? <MarketingTitle as="h1">{title}</MarketingTitle> : undefined}</>
                )}
                <VerticalSpacing bottom={10}>
                    <Body>
                        <i>{description}</i>
                    </Body>
                </VerticalSpacing>
                {!!userBio && (
                    <VerticalSpacing bottom={4}>
                        <Body>{userBio}</Body>
                    </VerticalSpacing>
                )}
                {!!profileLink.length && (
                    <VerticalSpacing bottom={40}>
                        <UseCaseLink target="_blank" href={profileLink}>
                            <Body>{profileLink.replace("https://", "")}</Body>
                        </UseCaseLink>
                    </VerticalSpacing>
                )}
                {useCTA && (
                    <ButtonWrapper>
                        <Link href={link} passHref>
                            <MarketingCTA text={CTAText} size={CTASize.L} />
                        </Link>
                    </ButtonWrapper>
                )}
            </MarketingUserCaseText>
        </div>
        <div>
            <OptionalLink target="_blank" href={profileLink}>
                <DesktopImage>{desktopImage}</DesktopImage>
                <MobileImage>{mobileImage}</MobileImage>
            </OptionalLink>
        </div>
    </MarketingUseCaseHeaders>
);
